import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  DeleteTrashBinBusinessRequest,
  DeleteTrashBinBusinessSuccessResponseInfo,
} from '@/coreInfrastructureModule/axios/generated/trashBinManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';

/**
 * DeleteTrashBinBusinessUseCase
 */
export class DeleteTrashBinBusinessUseCase {
  /**
   * ゴミ箱内の取引情報を削除するUseCase
   * @param repository - ゴミ箱のリポジトリ
   * @param trashBinBusinessIdArray - 削除する取引情報のID一覧
   */
  static async Execute(
    repository: ITrashBinRepository,
    trashBinBusinessIdArray: Array<string>
  ): Promise<INetworkResult<DeleteTrashBinBusinessSuccessResponseInfo, IError>> {
    const request: DeleteTrashBinBusinessRequest = {
      deleteTrashBinBusinessIdArray: trashBinBusinessIdArray,
    };
    const networkResult = await repository.deleteTrashBinBusiness(request);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data,
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
